/**
 * AnimatedView Component
 * 
 * Wrapper component for animated view transitions
 * - Uses react-native-reanimated for smooth animations
 * - FadeIn animation on mount (500ms duration)
 * - Spring transition for layout changes
 * 
 * @component
 * @param {React.ReactNode} children - Child components to animate
 * @param {Object} [style] - Optional style object
 */
import React, {  } from 'react';
import { View } from 'react-native';
import { FadeIn, LinearTransition } from 'react-native-reanimated';

function AnimatedView({ children, style }) {

    return (
        <View entering={FadeIn.duration(500)} layout={LinearTransition.springify()} style={style || {}}>
            {children}
        </View>
    );
}


export default AnimatedView;
